import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=1e9d1960&scoped=true&"
import script from "./CourseCard.vue?vue&type=script&lang=ts&"
export * from "./CourseCard.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCard.vue?vue&type=style&index=0&id=1e9d1960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9d1960",
  null
  
)

export default component.exports